export function getHash() {
  return Math.round(Math.random() * 10000000000000)
}

export function isNumber(number) {
  return isFinite(number)
}
